// extracted by mini-css-extract-plugin
export default {"container":"confirmation-modal_container__y-D9R","body":"confirmation-modal_body__CZTQQ","padding_bottom":"confirmation-modal_padding_bottom__sxhIh"};